'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBaseballOutline = function IoIosBaseballOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.9 21.8v0.1c-0.8 7.6-7 13.6-14.6 14.3h-0.1c-0.2 0-0.3 0.1-0.4 0.1h-1c-9 0-16.3-7.3-16.3-16.3v-1c0-0.2 0.1-0.2 0.1-0.4v-0.2c0.7-7.5 6.7-13.7 14.3-14.6 0.6 0 1.2 0 1.9 0 8.9 0 16.2 7.2 16.2 16.2 0 0.5 0 1.1-0.1 1.6v0.2z m-1.2-1.8c0-8.2-6.7-14.9-15-14.9-0.2 0-0.3 0.1-0.6 0.1 0 0.8 0.2 1.6 0.3 2.4l1.6-0.5 0.4 1.2-1.6 0.5c0.1 0.6 0.3 1.1 0.5 1.7 0.2 0.4 0.4 0.8 0.6 1.2l1.4-0.9 0.7 1-1.5 1c0.5 1 1.2 1.8 2 2.6l1.1-1.2 0.9 1-1.1 1.1c0.8 0.8 1.7 1.4 2.6 2l1-1.4 1.1 0.7-1 1.3c0.4 0.2 0.8 0.4 1.2 0.6 0.5 0.2 1.1 0.3 1.7 0.5l0.6-1.6 1.1 0.4-0.4 1.5c0.7 0.2 1.5 0.3 2.3 0.3 0-0.2 0.1-0.4 0.1-0.6z m-29.9 0c0 8.2 6.7 14.9 15 14.9h0.3c-0.1-0.7-0.1-1.3-0.3-2l-1.7 0.5-0.4-1.2 1.8-0.6c-0.1-0.6-0.4-1.2-0.6-1.8-0.2-0.4-0.3-0.7-0.5-1.1l-1.5 1-0.7-1 1.6-1.1c-0.6-1-1.3-1.9-2-2.8l-1.4 1.4-0.8-0.9 1.3-1.3c-0.8-0.8-1.7-1.4-2.6-2l-1.1 1.7-1.1-0.7 1.1-1.6c-0.4-0.1-0.8-0.4-1.2-0.5-0.6-0.3-1.2-0.5-1.8-0.7l-0.6 1.9-1.2-0.4 0.5-1.8c-0.7-0.1-1.4-0.1-2.1-0.2v0.3z m16.5 14.8c6.9-0.7 12.4-6 13.2-12.9-0.8-0.1-1.8-0.3-2.6-0.4l-0.7 2.1-1.2-0.4 0.6-2c-1.1-0.3-2.2-0.7-3.2-1.3l-1.2 1.8-1-0.7 1.1-1.6c-1-0.7-2-1.4-2.9-2.2l-1.5 1.5-0.8-0.9 1.5-1.5c-0.8-0.8-1.5-1.8-2.1-2.8l-1.7 1.1-0.7-1 1.7-1.2c-0.5-1-0.9-2.1-1.2-3.2l-2 0.6-0.4-1.2 2.1-0.6c-0.2-1-0.3-1.8-0.4-2.8-6.9 0.9-12.3 6.4-13 13.2 0.8 0.1 1.6 0.2 2.4 0.3l0.7-1.7 1.1 0.3-0.5 1.8c1.1 0.3 2.2 0.7 3.3 1.2l1-1.5 1.1 0.7-1 1.4c1 0.7 1.9 1.4 2.8 2.2l1.3-1.3 0.9 0.9-1.4 1.3c0.9 0.9 1.6 1.9 2.2 2.9l1.5-1 0.7 1.1-1.6 1c0.6 1.1 1 2.2 1.3 3.2l1.8-0.5 0.4 1.2-1.9 0.6c0.2 0.8 0.2 1.6 0.3 2.3z' })
        )
    );
};

exports.default = IoIosBaseballOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-baseball-outline.js
// module id = 2312
// module chunks = 0